import { getBaseUrl } from '../../maps/apiEnvironmentMap';
import { ExitConfirmation } from '../microservices';

const API_KEY = process.env.REACT_APP_API_KEY;
export class ExitConfirmationRequestPOST {
  readonly method: string = 'operation/exit/confirmation';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }
  public generateContent(
    packageCandidateId: number,
    lockerPositionId: number,
    receiverName?: string,
    receiverSignature?: string
  ) {
    const params: ExitConfirmationPayload = {
      packageCandidateId: packageCandidateId,
      lockerPositionId: lockerPositionId,
    };
    if (receiverName) {
      params.receiverName = receiverName;
    }
    if (receiverSignature) {
      params.receiverSignature = receiverSignature;
    }
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}
type ExitConfirmationPayload = {
  packageCandidateId: number;
  lockerPositionId: number;
  receiverName?: string;
  receiverSignature?: string;
};
export type ExitConfirmationResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    exitConfirmation: ExitConfirmation;
    versionFails: number;
  };
};
